export const texts = {
    ru: {
        header: {
            browserLanguage: 'Язык браузера',
        },
        content: {
            edit: 'Редактировать ',
            save: ' и сохраните, чтобы перезагрузить.',
            learn: 'Изучите React',
        },
        transliter: {
            inputCyr: 'Введите текст кириллицы - получите ссылку:',
            inputLat: 'Введите текст латинскими литерами - получите ссылку:',
            holder: 'Введите Ваш текст',
        },
        rate: {
            title: 'Определяем рейтинг по Like / Dislike',
            name: 'Рейтинг:'
        },
        date: {
            date: 'Дата:',
            time: 'Время'
        }
    },
    ua: {
        header: {
            browserLanguage: 'Мова браузера',

        },
        content: {
            edit: 'Редагувати ',
            save: ' і збережіть для перезавантаження.',
            learn: 'Вивчіть React',
        },
        transliter: {
            inputCyr: 'Введіть текст кирилиці - отримайте посилання:',
            inputLat: 'Введіть текст латинськими літерами – отримайте посилання:',
            holder: 'Введіть текст',
        },
        rate: {
            title: 'Визначаємо рейтинг по Like / Dislike',
            name: 'Рейтинг:'
        },
        date: {
            date: 'Дата:',
            time: 'Час'
        }
    },
    en: {
        header: {
            browserLanguage: 'Browser language',
        },
        content: {
            edit: 'Edit ',
            save: ' and save to reload.',
            learn: 'Learn React',
        },
        transliter: {
            inputCyr: 'Enter Cyrillic text - get a link:',
            inputLat: 'Enter text in Latin letters - get a link:',
            holder: 'Enter your text',
        },
        rate: {
            title: 'We determine the rating by Like / Dislike',
            name: 'Rating:'
        },
        date: {
            date: 'The Date:',
            time: 'Time'
        }
    },
};